import { cn } from '@/lib/utils';

/**
 * Design system §6: 8px bars in `--divider`, typically stacked at 100 / 88 / 64% widths.
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('h-2 animate-pulse rounded-full bg-divider', className)} {...props} />;
}

export { Skeleton };
